import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './components/Toast';
import Layout from './components/Layout';
import Login from './pages/Login';
import ScriptPage from './pages/script/ScriptPage';
import ScriptLibrary from './pages/script/ScriptLibrary';
import PodcastSetupPage from './pages/podcast/PodcastSetupPage';
import PodcastScriptViewer from './pages/podcast/PodcastScriptViewer';
import CastManagerPage from './pages/podcast/CastManagerPage';
import VideoUpload from './pages/video/VideoUpload';
import ShortformEditor from './pages/video/ShortformEditor';
import VideoLibrary from './pages/video/VideoLibrary';
import AdminPage from './pages/admin/AdminPage';
import ProjectList from './pages/v3/ProjectList';
import ProjectEditor from './pages/v3/ProjectEditor';
import NewProject from './pages/v3/NewProject';
import Landing from './pages/Landing';
import TokenPage from './pages/TokenPage';
import DashboardPage from './pages/DashboardPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#0D1117' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 48, height: 48, border: '4px solid #2A3441', borderTop: '4px solid #4CAF50', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }} />
        <span style={{ color: '#8B949E', fontSize: 14 }}>로딩 중...</span>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" />;
  if (user.role !== 'admin') return <Navigate to="/script" />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return null;

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/v3/project" /> : <Landing />} />
      <Route path="/login" element={user ? <Navigate to="/v3/project" /> : <Login />} />
      <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route path="/script" element={<ScriptPage />} />
        <Route path="/script/library" element={<ScriptLibrary />} />
        <Route path="/podcast/setup" element={<PodcastSetupPage />} />
        <Route path="/podcast/cast" element={<CastManagerPage />} />
        <Route path="/podcast/view/:id" element={<PodcastScriptViewer />} />
        <Route path="/podcast/script" element={<PodcastScriptViewer />} />
        <Route path="/video/editor" element={<ShortformEditor />} />
        <Route path="/video/library" element={<VideoLibrary />} />
        <Route path="/v3/project" element={<ProjectList />} />
        <Route path="/v3/project/new" element={<NewProject />} />
        <Route path="/v3/project/:id" element={<ProjectEditor />} />
        <Route path="/tokens" element={<TokenPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
